import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const useIsImageUploading = (targetString: string) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const prevImageSource = useRef<string | null>();
  const [isImageUploading, setIsImageUploading] = useState(false);
	const isLoadingImageLink = useSelector(state => state.editor.ui.conetentsLoading[targetString]);
  
  useEffect(() => {
    const imageElement = imageRef.current;
    if (!imageElement) return;
    const turnOffLoading = () => {
      setIsImageUploading(false);
      prevImageSource.current = imageRef.current?.getAttribute('src');
    }
    imageElement.addEventListener('load', turnOffLoading);
    imageElement.addEventListener('error', turnOffLoading);
    return () => {
      imageElement.removeEventListener('load', turnOffLoading);
      imageElement.removeEventListener('error', turnOffLoading);
    } 
  }, []);

	useEffect(() => {
    if (!isLoadingImageLink) {
      const currentImageSource = imageRef.current?.getAttribute('src');
      const isChangedImageSource = prevImageSource.current !== currentImageSource;
      if (isChangedImageSource) return;
      setIsImageUploading(false);
      return;
    }
		setIsImageUploading(true);
	}, [isLoadingImageLink]);

  return {
    imageRef,
    isImageUploading,
  }
}

export default useIsImageUploading;